<template>
  <v-row ref="editForm" class="edit-form" no-gutters>

    <v-col cols="12" sm="11">
      <v-radio-group v-model="userForm.anrede"
                     hide-details
                     row>
        <v-radio label="Frau"
                 value="Frau"
                 color="primary" />
        <v-radio label="Herr"
                 value="Herr"
                 color="primary"/>
        <v-radio label="keine Angabe"
                 value="kA"
                 color="primary" />
      </v-radio-group>
    </v-col><v-col cols="0" sm="1"/>

    <v-col cols="12" sm="6">
      <v-text-field v-model="userForm.titel"
                    label="Titel"/>
    </v-col><v-col cols="0" sm="6"/>

    <v-col cols="12" sm="6">
      <v-text-field v-model.trim="userForm.vorname"
                    v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{2,}$/ }"
                    :error-messages="errors.collect('firstname')"
                    data-vv-as="Vorname"
                    class="required"
                    name="firstname"
                    label="Vorname" />
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field v-model.trim="userForm.nachname"
                    v-validate="{ required: true, regex: /[^0-9!§$%&\/()=?#*+{\[\]}]{2,}$/ }"
                    :error-messages="errors.collect('lastname')"
                    data-vv-as="Nachname"
                    class="required"
                    name="lastname"
                    label="Nachname" />
    </v-col>

    <v-col cols="12" sm="6">
      <date-field v-model="userForm.geburt"
                  v-validate="'required|date_format:DD.MM.YYYY'"
                  :error-messages="errors.collect('geburt')"
                  data-vv-as="Geburtsdatum"
                  class="required"
                  hint="tt.mm.jjjj"
                  name="geburt"
                  label="Geburtsdatum"/>
    </v-col>

    <v-col cols="12" sm="6">
      <v-combobox v-model="userForm.staat"
                :items="countryList"
                class="required"
                name="staat"
                label="Staatsangehörigkeit Land" />
    </v-col>

  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import countries from "@/store/config/countries";
import DateField from "@/components/DateField";
export default {
  name: "EditPerson",
  components: { DateField },
  mixins: [ ValidationMixin ],
  props: {
    userForm: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      countryList: countries.countryList
    };
  }
};
</script>
